<template>
  <v-layout wrap lp-footer align-end>
    <picture>
      <source srcset="/img/logo_color.webp" type="image/webp" />
      <source srcset="/img/logo_color.png" type="image/png" />
      <img loading="lazy" src="/img/logo_color.png" alt="[Logo]" class="logo-img" />
    </picture>
    <v-spacer></v-spacer>
    <div class="copy-rights">Copyright © {{ copyRightYear }} fondi Inc. All Rights Reserved.</div>
  </v-layout>
</template>

<script>
export default {
  props: {
    copyRightYear: { type: String, default: '2022' },
  },
};
</script>

<style scoped>
.lp-footer {
  position: relative;
  height: 50px;
  background-color: #fff;
  padding: 0 8px 10px 15px;
}
.logo-img {
  margin-top: 10px;
  width: 100px;
  height: 28px;
}
.copy-rights {
  font-weight: bold;
  color: #454545;
  font-size: 14px;
}
@media (max-width: 767px) {
  .lp-footer {
    height: 35px;
    padding-right: 0;
  }
  .logo-img {
    margin-top: 7.5px;
    width: 65px;
    height: 18px;
  }
  .copy-rights {
    font-size: 10px;
    transform: scale(0.7);
    transform-origin: right;
    position: absolute;
    bottom: 4px;
    right: 6px;
    white-space: nowrap;
    text-align: right;
  }
}
@media (max-width: 360px) {
  .copy-rights {
    transform: scale(0.6);
    bottom: 6px;
    right: 4px;
  }
}
</style>
